import React from 'react'
import PropTypes from 'prop-types'
import { polyglot } from '../../../index'

class Select extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      labelSize: props.expandInputArea ? 3 : 6,
      otherIsSelected: false,
      options: props.options
    }
    this.renderOther = this.renderOther.bind(this)
    this.renderSelect = this.renderSelect.bind(this)
    this.handleOtherFieldChange = this.handleOtherFieldChange.bind(this)
  }

  componentWillMount () {
    if (this.props.visibleValues) {
      const updatedOptions = []
      this.props.options.forEach(element => {
        this.props.visibleValues.forEach(id => {
          if (Number(element.value) === id) {
            updatedOptions.push(element)
          }
        })
      })
      this.setState({
        options: updatedOptions
      })
    }
  }

  handleChange (e) {
    const name = e.target.name
    const value = e.target.value
    console.log(value)
    if (e.target.value === 'other') {
      this.setState({
        otherIsSelected: true,
        [name]: ''
      })
    } else {
      this.setState({
        [name]: value
      })
    }
    if (this.props.parentName) {
      this.props.getFieldValue(name, value, this.props.parentName)
    } else {
      this.props.getFieldValue(name, value)
    }
  }

  handleOtherFieldChange (e) {
    if (e.target.value === '') {
      this.setState({
        otherIsSelected: false
      })
    } else {
      this.handleChange(e)
    }
  }

  renderOther () {
    return <input
      type='text'
      name={this.props.name}
      value={this.state[this.props.name]}
      onChange={e => this.handleOtherFieldChange(e)}
      required={this.state.otherIsSelected}
      placeholder={polyglot.t('staticFields.commonFields.specify')}
      className='form-control col-sm-6' />
  }

  renderSelect () {
    return <select defaultValue={this.props.savedData || ''} required={this.props.required} className='form-control' name={this.props.name} id='select' onChange={(e) => this.handleChange(e)}>
      <option disabled hidden value={''} />
      {
        this.state.options.map(function (element) {
          return (<option key={element.value} value={element.value} label={polyglot.t(element.label)}>{polyglot.t(element.label)}</option>)
        })
      }
    </select>
  }

  renderDefault () {
    return <div className='form-group'>
      <label className={`col-xs-${this.state.labelSize} control-label`}>{polyglot.t(this.props.label)}</label>
      <div className={`col-xs-${12 - this.state.labelSize}`}>
        {this.state.otherIsSelected
          ? this.renderOther()
          : this.renderSelect()
        }
      </div>
    </div>
  }
  renderWithAddon () {
    return <div className='input-group'>
      {this.props.label
        ? <label className={`col-xs-${this.state.labelSize} control-label`}>{polyglot.t(this.props.label)}</label>
        : null
      }
      {this.props.addon
        ? <div className='input-group-addon'>{polyglot.t(this.props.addon)}</div>
        : null
      }

      <div className=''>
        {this.state.otherIsSelected
          ? this.renderOther()
          : this.renderSelect()
        }
      </div>
    </div>
  }
  render () {
    if (this.props.addon) {
      return this.renderWithAddon()
    } else {
      return this.renderDefault()
    }
  }
}

Select.propTypes = {
  label: PropTypes.string,
  addon: PropTypes.string,
  options: PropTypes.array.isRequired,
  getFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  savedData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  parentName: PropTypes.string,
  visibleValues: PropTypes.array,
  expandInputArea: PropTypes.bool
}

Select.defaultProps = {
  required: false
}

export {Select}



// WEBPACK FOOTER //
// ./src/components/common/Select/Select.js